<template>
    <div class="control-group octopus-booking-status">
        <select ref="input" class="form-control form-control-lg status-tom-selector" id="bookingStatus" name="bookingStatus">
            <option v-for="status of statuses" :data-has_date="status.has_date" :bcolor="status.color"
                    :value="status.booking_status_id">{{ status.name }}
            </option>
        </select>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import TomSelect from 'tom-select'
import {getBookingStatuses} from '@/modules/common/api'

export default {
    name: "selectBookingStatus",
    props: {
        booking_status: {
            type: Object,
            default: () => {
                return {}
            },
        },
        toEstimate: {
            type: Object,
            default: () => {
                return {}
            },
        },
        toInvoice: {
            type: Object,
            default: () => {
                return {}
            },
        },
        toGiftCard: {
            type: Object,
            default: () => {
                return {}
            },
        },
        toTodo: {
            type: Object,
            default: () => {
                return {}
            },
        },
        viewPage: {
            default() {
                return false
            }
        },
        bookingId: {
            default() {
                return 0
            }
        },
        value: null,
      bookingStatuses:{
        type: Array
      }
    },
    data() {
        return {
            select: null,
            statuses: [],
            selected: this.value
        }
    },
    mounted() {
        let vm = this;
        if(this.bookingStatuses){
          this.statuses = this.bookingStatuses
          this.afterGettingData()
        }else{
          getBookingStatuses()
              .then(response => {
                this.statuses = response.data
                this.afterGettingData()
              })
        }
    },
    methods: {
        showProductsPopup() {
            let vm = this
            popupi_alert_confirm('Create invoice', 'Do you want to create an invoice for a service or product?', 'Products', 'Services');
            $(".confirm").click(function () {
                vm.select.addItem($('#isProducts').val(), true)
                if (typeof window.check_booking_status === 'function') {
                    window.check_booking_status();
                }
                $('#popupi').modal('hide');
            });
            $(".cancel").click(function () {
                $('#popupi').modal('hide');
            });
        },
      afterGettingData(){
        this.$nextTick(() => {
          let statusObject = null;
          // Retrieve the status object from local storage
          let storedStatus = localStorage.getItem('selected_booking_status');
          if (storedStatus) {
            // Parse the string back to an object
            statusObject = JSON.parse(storedStatus);
            localStorage.removeItem('selected_booking_status')
          }
          // I added the variable to window to use it in jquery in other pages
          this.select = window.statusesSelect = new TomSelect(this.$refs['input'], {
            // to disable search
            controlInput: null
          })
          if (statusObject && statusObject.hasOwnProperty('booking_status_id')) {
            this.select.addItem(statusObject.booking_status_id, true)
            EventBus.$emit('onBookingStatusChange', statusObject);
            this.selected = statusObject.booking_status_id;
            $(`.status-tom-selector`).css('background-color', this.statuses.find(status => status.booking_status_id == statusObject.booking_status_id).color)
          }else if (this.booking_status && this.booking_status.hasOwnProperty('booking_status_id')) {
            this.select.addItem(this.booking_status.booking_status_id, true)
            EventBus.$emit('onBookingStatusChange', this.booking_status);
            this.selected = this.booking_status.booking_status_id;
            $(`.status-tom-selector`).css('background-color', this.statuses.find(status => status.booking_status_id == this.booking_status.booking_status_id).color)
          }else if (this.toEstimate.hasOwnProperty('booking_status_id')) {
            this.select.addItem(this.toEstimate.booking_status_id, true)
            EventBus.$emit('onBookingStatusChange', this.toEstimate);
            this.selected = this.toEstimate.booking_status_id;
            $(`.status-tom-selector`).css('background-color', this.statuses.find(status => status.booking_status_id == this.toEstimate.booking_status_id).color)
          } else if (this.toInvoice.hasOwnProperty('booking_status_id')) {
            this.select.addItem(this.toInvoice.booking_status_id, true)
            EventBus.$emit('onBookingStatusChange', this.toInvoice);
            this.selected = this.toInvoice.booking_status_id;
            $(`.status-tom-selector`).css('background-color', this.statuses.find(status => status.booking_status_id == this.toInvoice.booking_status_id).color)
            //if create invoice show popup to select if services or products
            if ($('#isProducts').val() != "0") {
              this.showProductsPopup()
            } else {
              $('#isProducts').val(0);
            }
          } else if (this.toGiftCard.hasOwnProperty('booking_status_id')) {
            this.select.addItem(this.toGiftCard.booking_status_id, true)
            EventBus.$emit('onBookingStatusChange', this.toGiftCard);
            this.selected = this.toGiftCard.booking_status_id;
            $(`.status-tom-selector`).css('background-color', this.statuses.find(status => status.booking_status_id == this.toGiftCard.booking_status_id).color)
          }   else {
            this.select.addItem(this.toTodo.booking_status_id, true);
            EventBus.$emit('onBookingStatusChange', this.toTodo);
            this.selected = this.toTodo.booking_status_id;
            $(`.status-tom-selector`).css('background-color', this.statuses.find(status => status.booking_status_id == this.toTodo.booking_status_id).color)
          }

          $(`.status-tom-selector`).css('border', 'none')
          this.select.on('item_add', (value, item) => {
            let status = this.statuses.find(status => status.booking_status_id == value);
            EventBus.$emit('onBookingStatusChange', status);
            this.selected = status.booking_status_id;
            $(`.status-tom-selector`).css('background-color', status.color)
            if (this.viewPage && this.bookingId){
              localStorage.setItem('selected_booking_status', JSON.stringify(status));
              // Redirect to the new page
              window.location.href = `/booking/edit/${this.bookingId}`;
            }
          })
        })
      }
    },
    watch: {
        selected :{
             handler: function (value) {
            this.$emit('input', parseInt(value))
             },
            deep: true
        },
        booking_status :{
            handler: function (value) {
                if (value && value.hasOwnProperty('booking_status_id') && this.select) {
                    this.select.addItem(value.booking_status_id, true)
                }
            },
            deep: true

        },

    }
}
</script>
<style scoped>

.octopus-booking-status{
    display: flex;
    align-items: center;
}
</style>